import React, { useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'
import ReactSelect from 'react-select'
import axios from 'axios'
import classNames from 'classnames'

import { stateList, cardTypes } from '../enums'
import { selectStyles } from '../Container.styles'

const Select = props => {
  const { field, cssClass, control, errors } = props
  const { id, label } = field
  const hasErrors = errors[id]
  const [options, setOptions] = useState([{ value: 'Options not set', label: 'Options not set' }])
  const [countryList, setcountryList] = useState([])
  const [siteCountry, setSiteCountry] = useState('nz')

  useEffect(() => {
    axios.get('/cms/regions').then(res => {
      setcountryList(res.data)
    })

    setSiteCountry(window.location.hostname.includes('.nz') ? 'nz' : 'au')
  }, [])

  useEffect(() => {
    field.selectOptions === 'stateList'
      ? setOptions(stateList)
      : field.selectOptions === 'countryList'
      ? setOptions(countryList)
      : field.selectOptions === 'cardTypes'
      ? setOptions(cardTypes)
      : setOptions([{ value: 'Options not set', label: 'Options not set' }])
  }, [field, countryList])

  return (
    <div
      className={classNames('fieldContainer', cssClass, { error: hasErrors })}
      key={`field-${id}`}
    >
      <Controller
        name={id}
        control={control}
        render={({ field }) => (
          <ReactSelect
            {...field}
            options={options}
            name={label}
            placeholder={label}
            isClearable
            styles={selectStyles}
          />
        )}
      />

      {errors[id] && (
        <div className="error-message">
          <img src="/themes/thrifty/assets/images/form-error.svg" />
          {errors[id]?.message}
        </div>
      )}
    </div>
  )
}

export default Select
